import React, { useEffect, useState } from "react";
import Input from "componentsTemplate/Input/Input";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import NcLink from "componentsTemplate/NcLink/NcLink";
import Heading2 from "componentsTemplate/Heading/Heading2";
import LayoutOthers from "pages/layouts/LayoutOthers";
import Select from "componentsTemplate/Select/Select";

import useAuth from "hooks/useAuth";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup"; // Import this package for TypeScript support
import { showToastError, showToastSuccess } from "utils/toasts";

// Icons
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CountrySelect from "components/forms/inputs/SelectCountry";
import InputMasked from "componentsTemplate/Input/InputMasked";
import axios from "axios";

interface RegistrationFormValues {
  name: string;
  email: string;
  phone: string;
  message: string;
  // linkedin: string | undefined;
  // facebook: string | undefined;
  // instagram: string | undefined;
  state: string | undefined;
  city: string | undefined;
  country: string | undefined;
}

const validationSchema = yup.object().shape({

  name: yup.string().required("O nome é obrigatório"),
  email: yup
    .string()
    .required("O e-mail é obrigatório")
    .email("Digite um e-mail válido"),
  phone: yup.string().required("O número de WhatsApp é obrigatório"),
  message: yup.string().required("A mensagem é obrigatória"),
  // linkedin: yup.string(),
  // facebook: yup.string(),
  // instagram: yup.string(),
  state: yup.string(),
  city: yup.string(),
  country: yup.string(),
});

const PageContactRadar = () => {
  const navigate = useNavigate();
  const { register, contactRadar } = useAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const data = await index();
    //     setInterestsData(data);
    //   } catch (error) {
    //     // Lidar com erros, se necessário
    //   }
    // };

    // fetchData();
  }, []);

  const { handleSubmit, control, formState, watch, setValue } =
    useForm<RegistrationFormValues>({
      resolver: yupResolver(validationSchema),
      // defaultValues: {
      //   document_type_id: 1, 
      //   was_invited: false,
      // },
    });

  const { errors } = formState;

  const onSubmit = async (data: RegistrationFormValues) => {

    setLoading(true);
    try {

      let dataForm = {

        name: data.name,
        email: data.email,
        phone: data.phone,
        message: data.message,
        // linkedin: data.linkedin,
        // facebook: data.facebook,
        // instagram: data.instagram,
        state: data.state,
        city: data.city,
        country: data.country,
      };

      await contactRadar(dataForm);

      // window.location.reload();
      showToastSuccess(
        "Formulário enviado com sucesso!"
      );
      navigate("/");

    } catch (error) {
      showToastError("Ocorreu um erro ao fazer o formulário");
      setLoading(false);
    }
  };

  // const verificarEstado = (e: any, field: any) => {
  //   if (selectedCountry.code == "BR") {
  //     if (e.target.value.length > 2) {
  //       showToastError("Os estados brasileiros contém apenas 2 caracteres.");
  //       return;
  //     } else {
  //       field.onChange(e.target.value);
  //     }
  //   } else {
  //     field.onChange(e.target.value);
  //   }
  // };

  // const getAddressFromCep = async (cep: string) => {
  //   try {
  //     const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
  //     const addressData = response.data;

  //     if (!addressData.erro) {
  //       // Preencha os campos do endereço com os dados recebidos
  //       setValue("address", addressData.logradouro || "");
  //       setValue("complement", addressData.complemento || "");
  //       setValue("district", addressData.bairro || "");
  //       setValue("city", addressData.localidade || "");
  //       setValue("state", addressData.uf || "");
  //     } else {
  //       // Se a API ViaCep retornar erro, exiba um Toast
  //       showToastError(
  //         "Não foi possível encontrar o endereço com o CEP fornecido."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Erro ao obter endereço do CEP", error);
  //     showToastError("Ocorreu um erro ao buscar o endereço.");
  //   }
  // };

  // Função chamada quando o CEP é alterado
  // const handleCepChange = (cep: string) => {
  //   // Remova caracteres não numéricos do CEP
  //   const cleanCep = cep.replace(/\D/g, "");

  //   // Verifique se o CEP tem o comprimento correto
  //   if (cleanCep.length === 8) {
  //     // Faça a chamada à API ViaCep
  //     setValue("postal_code", cep);
  //     getAddressFromCep(cleanCep);
  //   }
  // };

  return (
    <LayoutOthers>
      <header className="text-center max-w-2xl mx-auto mb-14 sm:mb-16 lg:mb-20">
        <Heading2>Contato Radar</Heading2>
        <span className="block text-sm text-primary-700 sm:text-base dark:text-primary-200">
          Entre em contato com a nossa equipe
        </span>

        <div className="w-full flex justify-center mt-5 gap-4">

          <a href="https://www.instagram.com/radarevoce/"  target="_blank" className="hover:text-gray-600 text-gray-500">
            <svg className="w-8 h-8" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_17_63)">
                <path d="M24 4.32187C30.4125 4.32187 31.1719 4.35 33.6938 4.4625C36.0375 4.56562 37.3031 4.95938 38.1469 5.2875C39.2625 5.71875 40.0688 6.24375 40.9031 7.07812C41.7469 7.92188 42.2625 8.71875 42.6938 9.83438C43.0219 10.6781 43.4156 11.9531 43.5188 14.2875C43.6313 16.8187 43.6594 17.5781 43.6594 23.9813C43.6594 30.3938 43.6313 31.1531 43.5188 33.675C43.4156 36.0188 43.0219 37.2844 42.6938 38.1281C42.2625 39.2438 41.7375 40.05 40.9031 40.8844C40.0594 41.7281 39.2625 42.2438 38.1469 42.675C37.3031 43.0031 36.0281 43.3969 33.6938 43.5C31.1625 43.6125 30.4031 43.6406 24 43.6406C17.5875 43.6406 16.8281 43.6125 14.3063 43.5C11.9625 43.3969 10.6969 43.0031 9.85313 42.675C8.7375 42.2438 7.93125 41.7188 7.09688 40.8844C6.25313 40.0406 5.7375 39.2438 5.30625 38.1281C4.97813 37.2844 4.58438 36.0094 4.48125 33.675C4.36875 31.1438 4.34063 30.3844 4.34063 23.9813C4.34063 17.5688 4.36875 16.8094 4.48125 14.2875C4.58438 11.9437 4.97813 10.6781 5.30625 9.83438C5.7375 8.71875 6.2625 7.9125 7.09688 7.07812C7.94063 6.23438 8.7375 5.71875 9.85313 5.2875C10.6969 4.95938 11.9719 4.56562 14.3063 4.4625C16.8281 4.35 17.5875 4.32187 24 4.32187ZM24 0C17.4844 0 16.6688 0.028125 14.1094 0.140625C11.5594 0.253125 9.80625 0.665625 8.2875 1.25625C6.70312 1.875 5.3625 2.69062 4.03125 4.03125C2.69063 5.3625 1.875 6.70313 1.25625 8.27813C0.665625 9.80625 0.253125 11.55 0.140625 14.1C0.028125 16.6687 0 17.4844 0 24C0 30.5156 0.028125 31.3312 0.140625 33.8906C0.253125 36.4406 0.665625 38.1938 1.25625 39.7125C1.875 41.2969 2.69063 42.6375 4.03125 43.9688C5.3625 45.3 6.70313 46.125 8.27813 46.7344C9.80625 47.325 11.55 47.7375 14.1 47.85C16.6594 47.9625 17.475 47.9906 23.9906 47.9906C30.5063 47.9906 31.3219 47.9625 33.8813 47.85C36.4313 47.7375 38.1844 47.325 39.7031 46.7344C41.2781 46.125 42.6188 45.3 43.95 43.9688C45.2812 42.6375 46.1063 41.2969 46.7156 39.7219C47.3063 38.1938 47.7188 36.45 47.8313 33.9C47.9438 31.3406 47.9719 30.525 47.9719 24.0094C47.9719 17.4938 47.9438 16.6781 47.8313 14.1188C47.7188 11.5688 47.3063 9.81563 46.7156 8.29688C46.125 6.70312 45.3094 5.3625 43.9688 4.03125C42.6375 2.7 41.2969 1.875 39.7219 1.26562C38.1938 0.675 36.45 0.2625 33.9 0.15C31.3313 0.028125 30.5156 0 24 0Z" fill="currentColor"/>
                <path d="M24 11.6719C17.1938 11.6719 11.6719 17.1938 11.6719 24C11.6719 30.8062 17.1938 36.3281 24 36.3281C30.8062 36.3281 36.3281 30.8062 36.3281 24C36.3281 17.1938 30.8062 11.6719 24 11.6719ZM24 31.9969C19.5844 31.9969 16.0031 28.4156 16.0031 24C16.0031 19.5844 19.5844 16.0031 24 16.0031C28.4156 16.0031 31.9969 19.5844 31.9969 24C31.9969 28.4156 28.4156 31.9969 24 31.9969Z" fill="currentColor"/>
                <path d="M39.6937 11.1843C39.6937 12.778 38.4 14.0624 36.8156 14.0624C35.2219 14.0624 33.9375 12.7687 33.9375 11.1843C33.9375 9.59053 35.2313 8.30615 36.8156 8.30615C38.4 8.30615 39.6937 9.5999 39.6937 11.1843Z" fill="currentColor"/>
              </g>
            </svg>
          </a>

          <a href="https://www.youtube.com/channel/UCoVaEWYxS5FgW6XdJ_t53Ig" target="_blank" className="hover:text-gray-600 text-gray-500">
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.499 6.203a2.994 2.994 0 00-2.11-2.12C19.76 3.5 12 3.5 12 3.5s-7.76 0-9.39.583a2.994 2.994 0 00-2.11 2.12C.003 8.055.003 12.005.003 12.005s0 3.95.497 5.802a2.994 2.994 0 002.11 2.12C4.24 20.5 12 20.5 12 20.5s7.76 0 9.39-.583a2.994 2.994 0 002.11-2.12c.497-1.852.497-5.802.497-5.802s0-3.95-.497-5.802zM9.75 15.025V8.985l5.75 3.02-5.75 3.02z" fill="currentColor"/>
            </svg>
          </a>

          <a href="https://www.linkedin.com/in/yolanda-papa-69a8b7310/"  target="_blank" className="hover:text-gray-600 text-gray-500">
            <svg className="w-8 h-8" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_17_68)">
                <path d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4062 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4062 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39062 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39062 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z" fill="currentColor"/>
              </g>
            </svg>
          </a>
        </div>
      </header>

      <form className="" onSubmit={handleSubmit(onSubmit)}>
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 divide-x-2">
              <div className="grid gap-6 px-8">
                {/* <div className="grid gap-2 grid-cols-1  md:grid-cols-2"> */}
                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Nome *
                  </span>
                  <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="name"
                          value={field.value || ""}
                        />
                        {errors.name && (
                          <small className="text-red-500">
                            {errors.name.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Endereço de Email *
                  </span>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="email"
                          autoComplete="username"
                          value={field.value || ""}
                        />
                        {errors.email && (
                          <small className="text-red-500">
                            {errors.email.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Numero (WhatsApp) *
                  </span>
                  <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                      <>
                        <InputMasked
                          {...field}
                          type="text"
                          className=""
                          autoComplete="phone"
                          mask="(99) 99999-9999"
                          value={field.value || ""}
                        />
                        {/* <Input {...field} type="text" autoComplete="phone" value={field.value || ''}/> */}
                        {errors.phone && (
                          <small className="text-red-500">
                            {errors.phone.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                {/* <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Linkedin
                  </span>
                  <Controller
                    name="linkedin"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="linkedin"
                          value={field.value || ""}
                        />
                        {errors.linkedin && (
                          <small className="text-red-500">
                            {errors.linkedin.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div> */}

                {/* <div className="h-20"></div> */}
              </div>

              <div className="grid gap-6 px-8">

              {/* <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Instagram
                  </span>
                  <Controller
                    name="instagram"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="instagram"
                          value={field.value || ""}
                        />
                        {errors.instagram && (
                          <small className="text-red-500">
                            {errors.instagram.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Facebook
                  </span>
                  <Controller
                    name="facebook"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="facebook"
                          value={field.value || ""}
                        />
                        {errors.facebook && (
                          <small className="text-red-500">
                            {errors.facebook.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div> */}

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    País
                  </span>
                  <Controller
                    name="country"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="country"
                          value={field.value || ""}
                        />
                        {errors.country && (
                          <small className="text-red-500">
                            {errors.country.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Estado
                  </span>
                  <Controller
                    name="state"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="state"
                          value={field.value || ""}
                        />
                        {errors.state && (
                          <small className="text-red-500">
                            {errors.state.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="h-20">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Cidade
                  </span>
                  <Controller
                    name="city"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Input
                          {...field}
                          type="text"
                          autoComplete="city"
                          value={field.value || ""}
                        />
                        {errors.city && (
                          <small className="text-red-500">
                            {errors.city.message}
                          </small>
                        )}
                      </>
                    )}
                  />
                </div>

              </div>
            </div>

            {/* Adicione um text area aqui */}
            <div className="h-20 px-4 mx-3 mt-5">
              <span className="text-neutral-800 dark:text-neutral-200">
                Mensagem *
              </span>
              <Controller
                name="message"
                control={control}
                render={({ field }) => (
                  <>
                    <textarea
                      {...field}
                      className="w-full h-36 p-4 mt-2 border border-neutral-200 dark:border-neutral-700 rounded-lg focus:ring-primary-500 focus:border-primary-500"
                    ></textarea>
                    {errors.message && (
                      <small className="text-red-500">
                        {errors.message.message}
                      </small>
                    )}
                  </>
                )}
              />
            </div>

            {/* {interestsData && (
              <div className="mt-8">
                <span className="text-neutral-800 dark:text-neutral-200">
                  Selecione seus interesses *
                </span>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-1 mt-5">
                  {interestsData?.map((interest: any) => (
                    <div key={interest.id} className="mr-4">
                      <div className="flex">
                        <Checkbox
                          id={`interesse_${interest.id}`}
                          checked={interests.includes(interest.id)}
                          inputProps={{ "aria-label": "controlled" }}
                          onChange={() => handleInterestChange(interest.id)}
                        />
                        <label
                          htmlFor={`interesse_${interest.id}`}
                          className="block mt-2 cursor-pointer"
                        >
                          {interest.name}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>

                {errors.interests && (
                  <small className="text-red-500">
                    {errors.interests.message}
                  </small>
                )}

              </div>
            )} */}

            <hr className="mt-20" />

            {/* <div className="mt-14">
              <Controller
                name="accept_terms"
                control={control}
                render={({ field }) => (
                  <>
                    <div className="flex">
                      <Checkbox
                        id="accept_terms"
                        {...field}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <label
                        htmlFor="accept_terms"
                        className="block mt-2 cursor-pointer"
                      >
                        Eu concordo e aceito integralmente com os <a target="blank" href="/termos-de-uso"><b>termos de uso</b></a>
                        *
                      </label>
                    </div>
                    <div className="pl-8 ">
                      {errors.accept_terms && (
                        <small className="text-red-500">
                          {errors.accept_terms.message}
                        </small>
                      )}
                    </div>
                  </>
                )}
              />
            </div> */}
          </>

        <div className="flex justify-center my-14">
          <ButtonPrimary
            // disabled={!selectedCountry}
            sizeClass="py-3 px-4 sm:py-3.5 sm:px-20"
            type="submit"
          >
            Enviar Formulário
          </ButtonPrimary>
        </div>
      </form>

      {/* <div className="mx-auto space-y-6 mt-8">
        <div className="relative text-center">
          <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
          </span>
          <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
        </div>

        <span className="block text-center text-neutral-700 dark:text-neutral-300">
          Já possuí conta? {` `}
          <NcLink href="/login">Ir para login</NcLink>
        </span>
      </div> */}
    </LayoutOthers>
  );
};

export default PageContactRadar;
